import { Link } from "react-router-dom";
import { Phone, MessageSquare, Truck, Home, PackageCheck } from "lucide-react";
import SEO from "@/components/SEO";
import { PHONE, PHONE_TEL } from "@/components/PublicLayout";

const STEPS = [
  {
    Icon: MessageSquare,
    title: "1. Get in Touch",
    text: "Call us on 07740051799 or fill in our quick quote form. Tell us your location, your renovation start date, and how long you'll need the unit.",
  },
  {
    Icon: Truck,
    title: "2. Delivery to Your Driveway",
    text: "We deliver the trailer directly to your driveway and connect the electrics and water supply, so it's ready to use from day one. We'll show you exactly how everything works before we leave.",
  },
  {
    Icon: Home,
    title: "3. Cook as Normal",
    text: "Use your fully-equipped kitchen as normal throughout your renovation — hob, oven, fridge, dishwasher and washing machine all included. If the works overrun, you can simply extend your hire.",
  },
  {
    Icon: PackageCheck,
    title: "4. Collection",
    text: "When your kitchen is finished, we come back and collect the trailer at a time that suits you. We disconnect and take care of everything — leaving you to enjoy your finished kitchen.",
  },
];

export default function HowItWorks() {
  return (
    <div data-testid="how-it-works-page">
      <SEO
        title="How Temporary Kitchen Hire Works | Mobile Kitchen Company Surrey"
        description="How mobile kitchen hire Surrey works: enquiry, free quote, delivery and setup, flexible hire period and collection. Simple, reassuring temporary kitchen hire across Surrey."
      />
      <section className="bg-[#F8FAFC] border-b border-slate-200 py-14">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-4xl sm:text-5xl font-bold text-[#1A237E]">How Temporary Kitchen Hire Works</h1>
          <p className="mt-5 text-lg text-slate-600 max-w-3xl leading-relaxed">
            Hiring a mobile kitchen in Surrey couldn't be simpler. From your first call to final collection,
            we handle everything — so you can focus on your renovation, not on where dinner is coming from.
          </p>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4">
          <ol className="space-y-10">
            {STEPS.map(({ Icon, title, text }) => (
              <li key={title} className="flex gap-6" data-testid={`process-step-${title.split(".")[0].trim()}`}>
                <div className="shrink-0 h-14 w-14 rounded bg-[#1A237E] flex items-center justify-center">
                  <Icon className="h-6 w-6 text-white" />
                </div>
                <div>
                  <h2 className="text-xl sm:text-2xl font-semibold text-[#1A237E]">{title}</h2>
                  <p className="mt-2 text-base text-slate-700 leading-relaxed">{text}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section className="bg-[#1A237E] py-16" data-testid="how-it-works-cta">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h2 className="text-2xl sm:text-3xl font-bold text-white">Start With a Free, No-Obligation Quote</h2>
          <p className="mt-4 text-lg text-slate-300 max-w-2xl mx-auto">
            Tell us your dates and we'll take care of the rest. Mobile kitchen hire Surrey made simple.
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-4">
            <Link to="/contact" data-testid="hiw-quote-button" className="px-7 py-3.5 bg-white text-[#1A237E] font-semibold rounded hover:bg-slate-100 transition-colors">
              Get a Free Quote
            </Link>
            <a href={PHONE_TEL} data-testid="hiw-call-button" className="flex items-center gap-2 px-7 py-3.5 bg-white text-[#1A237E] font-semibold rounded hover:bg-slate-100 transition-colors">
              <Phone className="h-5 w-5" /> Call {PHONE}
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
